import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Nav, NavItem, NavLink } from "shards-react";
import { Link } from "react-router-dom";

const MainFooter = ({ contained, menuItems, copyright }) => (
  <footer className="main-footer d-flex p-2 px-3 bg-white border-top items-center">
    <Container fluid={contained}>
      <Row>
        <Nav>
          <NavItem key={0}>
            {/* <NavLink tag={Link} to={item.to}> */}
            <span className="copyright ml-auto my-auto mr-2">{copyright}</span>
            {/* </NavLink> */}
          </NavItem>
        </Nav>
      </Row>
    </Container>
  </footer>
);

MainFooter.propTypes = {
  /**
   * Whether the content is contained, or not.
   */
  contained: PropTypes.bool,
  /**
   * The menu items array.
   */
  menuItems: PropTypes.array,
  /**
   * The copyright info.
   */
  copyright: PropTypes.string
};

MainFooter.defaultProps = {
  contained: false,
  copyright: `Copyright © 2021 Otellu`,
  menuItems: [
    {
      title: "Home",
      to: "https://otellu.work/business"
    },
    {
      title: "About",
      to: "https://otellu.work/about"
    }
  ]
};

export default MainFooter;
